import qs from 'qs'

const createApiCallConfig = (apiActions, validateStatus = false) => params => (
    Object.freeze ({
        method: 'POST',
        url: matrixParams.ajax_url,
        ...validateStatus && { validateStatus: validateStatus },
        data: qs.stringify({
            action: apiActions[params.apiEndpoint],
            ...params.nonce && { ajax_nonce: params.nonce },
            ...params.session && { ajax_session: params.session },
            ...params.data && { data: JSON.stringify(params.data) }
        }, {
            skipNulls:false,
            strictNullHandling: true,
            skipEmptyString:false,
            allowEmptyArrays: true
        })
    })
)

export default createApiCallConfig